import { apiFetch } from './client';
import type { Bookmark, DuplicateGroup } from '@/types/models';

export interface BookmarkListFilters {
  tags?: string[];
  from?: string;
  to?: string;
  unassigned?: boolean;
  projectId?: string;
  q?: string;
  sort?: 'created_at' | 'title';
  order?: 'asc' | 'desc';
}

function buildQuery(filters: BookmarkListFilters): string {
  const params = new URLSearchParams();
  if (filters.tags && filters.tags.length > 0) params.set('tags', filters.tags.join(','));
  if (filters.from) params.set('from', filters.from);
  if (filters.to) params.set('to', filters.to);
  if (filters.unassigned) params.set('unassigned', 'true');
  if (filters.projectId) params.set('projectId', filters.projectId);
  if (filters.q) params.set('q', filters.q);
  if (filters.sort) params.set('sort', filters.sort);
  if (filters.order) params.set('order', filters.order);
  const qs = params.toString();
  return qs ? `?${qs}` : '';
}

export async function listBookmarks(
  filters: BookmarkListFilters = {},
): Promise<{ bookmarks: Bookmark[]; total: number }> {
  return apiFetch(`/api/bookmarks${buildQuery(filters)}`);
}

export interface CreateBookmarkBody {
  url: string;
  title: string;
  description?: string;
  notes?: string;
  tags?: string[];
  capturedAt?: string;
}

export async function createBookmark(body: CreateBookmarkBody): Promise<Bookmark> {
  return apiFetch('/api/bookmarks', { method: 'POST', body: JSON.stringify(body) });
}

export interface UpdateBookmarkBody {
  title?: string;
  description?: string;
  notes?: string;
  tags?: string[];
}

export async function updateBookmark(id: string, body: UpdateBookmarkBody): Promise<Bookmark> {
  return apiFetch(`/api/bookmarks/${id}`, { method: 'PATCH', body: JSON.stringify(body) });
}

export async function deleteBookmark(id: string): Promise<void> {
  await apiFetch(`/api/bookmarks/${id}`, { method: 'DELETE' });
}

export async function findDuplicates(): Promise<{ groups: DuplicateGroup[] }> {
  return apiFetch('/api/bookmarks/duplicates');
}

export async function assignBookmarkToProject(
  bookmarkId: string,
  projectId: string,
): Promise<void> {
  await apiFetch(`/api/bookmarks/${bookmarkId}/projects/${projectId}`, { method: 'POST' });
}

export async function unassignBookmarkFromProject(
  bookmarkId: string,
  projectId: string,
): Promise<void> {
  await apiFetch(`/api/bookmarks/${bookmarkId}/projects/${projectId}`, { method: 'DELETE' });
}
